// import { API_REQUEST, GET_ALL_SUPPLIER } from "../../../config/constants";

import { API_REQUEST, GET_ALL_SUPPLIER } from "../../../config/constants";

// const initialState = {};
// export default fu33nction AllSupplierHistorySlice(state = initialState, action) {
//   switch (action.type) {
//     case API_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_ALL_SUPPLIER:
//       const { data, filter } = action.payload;
//       return {
//         ...state,
//         loading: false,
//         potentialEmployers: action.payload,
//       };
//     default:
//       return state;
//   }
// }

const initialState = {};
// export default function AllSupplierHistorySlice(state = initialState, action) {
//   switch (action.type) {
//     case API_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_ALL_SUPPLIER:
//       const { data, filter } = action.payload;
//       // Check if filter is '2', then update the state accordingly
//       if (filter.filter === '2' || filter?.FilterPotential === '2' || filter?.FilterPotential === '3') {
//         return {
//           ...state,
//           loading: false,
//           potentialEmployers: data,
//         };
//       } else {
//         return {
//           ...state,
//           loading: false,
//           registeredEmployer: data,
//         };
//       }
//     default:
//       return state;
//   }
// }
export default function AllSupplierHistorySlice(state = initialState, action) {
  switch (action.type) {
    case API_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_SUPPLIER:
      const { data, filter } = action.payload;
      if (filter.filter === '2' || filter?.FilterPotential === '2') {
        return {
          ...state,
          loading: false,
          potentialEmployers: data,
        };
      } else if (filter.filter === '3' || filter?.FilterPotential === '3') {
        return {
          ...state,
          loading: false,
          blockedSuppliers: data,
        };
      } else {
        return {
          ...state,
          loading: false,
          registeredEmployer: data,
        };
      }
    default:
      return state;
  }
}
